<div class="dashboard-clinical-container">
  <app-detail-main-template>
    <div container-header>
      <h3>My Chases</h3>
      <div class="chase-land-stats">
        <div class="p-grid">
          <div class="p-col-8">
            <div class="chase-land-stats_keyItem"
              *ngFor="let item of headerStatistics; let i = index, trackBy: trackByIndex"
              [ngClass]="getStatisticsClass(item)">
              <span>{{item.key}}</span><br>
              <a class="chase-land-stats-item bold" [ngClass]="getHeaderItemClass(item.key)">
                <span (click)="applyFilter(item.key)">{{item.value}}</span>
              </a>
            </div>
            <div class="chase-land-stats_keyItem">
              <span>Overread Feedback\Acknowledgements</span><br>
              <a class="chase-land-stats-item bold" routerLink="/dashboard/clinical/orfeedback">{{ overreadFeedbackCount
                }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div container-body>
      <div class="p-grid p-fluid">
        <!-- [ngClass]="getClassForColumn()" -->
        <div class="p-col-12 p-md-12 p-lg-12">

          <app-server-grid 
          [configuration]="clinicalGridConfiguration" 
          [(request)]="serverRequest"
          [filterTemplate]="filterForm">

            
            <ng-template #filterForm let-form>
              <app-tab-menu orientation="left">
                <app-tab-panel header="Date Range for Date Completed">
                  <div class="p-grid p-col-12 p-md-12 p-lg-12">

                    <div class="p-col-6 p-md-6 p-lg-6">
                      <form-factory [formGroup]="form" [model]="startDate"></form-factory>
                    </div>
                    <div class="p-col-6 p-md-6 p-lg-6">
                      <form-factory [formGroup]="form" [model]="endDate"></form-factory>
                    </div>
                   
                  </div>
                </app-tab-panel>

              </app-tab-menu>
            </ng-template>

          </app-server-grid>

        </div>
      </div>
    </div>
  </app-detail-main-template>
</div>